import { GRAPHQL_ME_QUERIES } from 'graphql/me'
import type { TMeQueriesData, TMeQueriesName, TMeQueriesVariables } from 'graphql/me/types'
import { buildQueryHook } from 'lib/apollo-client/builders'

export const useMeQueries = buildQueryHook<TMeQueriesName, TMeQueriesVariables, TMeQueriesData>(GRAPHQL_ME_QUERIES)
